module.exports = __webpack_public_path__ + "static/media/nss.6765e127.jpeg";